import React from 'react'
import loginimg from './img/login-img.png';
import backarrow from './img/backarrrow.png';
import { Link } from 'react-router-dom';

export default function UpdatePassword() {
  return (
    <>
      <div className="container login-container">
        <div className="row">
          <div className="col-md-6 px-0">
            <img src={loginimg} alt="profile_img" />
          </div>
          <div className="col-md-6 login-form forgot-pass">
           

          </div>
        </div>
      </div>

    </>
  )
}
